import React, { Component } from 'react';
import { ButtonLoaddingSpinner } from '../components/Loading';
import { urls } from '../utils/urls.config';
import { Content } from '../components/Content';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

require('dotenv').config()



//const AUTH_ENDPOINT= 'https://sistemas.ufvjm.edu.br/api/v1/conta-institucional/authenticate';
const AUTH_ENDPOINT= 'https://sistemas.ufvjm.edu.br/api/v1/conta-institucional/authenticate';


class LoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showError: false,
            errors: [],
            loading: false,
            username: '',
            password: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.formValid = this.formValid.bind(this);
    };

    resetErrors = () => {
        this.setState({ showError: false, errors: [] });
    };

    componentWillMount() {
        localStorage.removeItem('token');
    }


    // async handleFormikSubmit(input, { setSubmitting }) {

    //     const response = await fetch(AUTH_ENDPOINT, {
    //         method: 'POST',
    //         body: new FormData(document.getElementById('login-form'))
    //     });

    //     const jsonResponse = await response.json();
    //     this.resetErrors()

    //     if (!response.ok) {
    //         this.setState({ showError: true, errors: [...this.state.errors, jsonResponse.error.message] });


    //         setSubmitting(false);
    //         return;
    //     }

    //     if (jsonResponse.error && jsonResponse.error.internal) {
    //         let messageInternalerror = "Erro interno no sistema: " + jsonResponse.error.message;
    //         this.setState({ showError: true, errors: [...this.state.errors, messageInternalerror] });
    //         setSubmitting(false);
    //         return;
    //     }

    //     setSubmitting(false);
    //     return this.handleRedirectRoute(jsonResponse);
    // };


    // handleRedirectRoute(jsonResponse) {
    //     let userId = jsonResponse.uid;
    //     let uri = jsonResponse.links.href;
    //     let token = jsonResponse.accessToken;

    //     console.log(jsonResponse);

    //     //Redireciona para a pagina de alteração de senha default
    //     if (jsonResponse.defaultPassword) {
    //         console.log("baseurl: " + process.env.PUBLIC_URL);
    //         console.log(this.props, urls.change);
    //         return this.props.history.push({
    //             pathname: urls.change.path,
    //             state: { uid: userId, uri: uri, token: token }
    //         })
    //     }

    //     //Redireciona para a pagina de conta existente
    //     if (jsonResponse.hasAccount) {
    //         let fullName = jsonResponse.fullName;
    //         let account = jsonResponse.account;
    //         return this.props.history.push({
    //             pathname: urls.exists.path,
    //             state: { uid: userId, fullName: fullName, account: account }
    //         })
    //     }

    //     //Redireciona para a pagina de escolha de conta institucional
    //     if (jsonResponse.accountChoices) {
    //         console.log("baseurl: " + process.env.PUBLIC_URL);
    //         return this.props.history.push({
    //             pathname: urls.choices.path,
    //             state: { uid: userId, uri: uri, token: token }
    //         })
    //     }
    // };

    handleSubmit = async (event) => {
        event.preventDefault();

        this.resetErrors();

        if (!this.formValid(event.target)) {
            return false;
        }

        this.setState({ loading: true });

        const response = await fetch(AUTH_ENDPOINT, {
            method: 'POST',
            body: new FormData(event.target)
        });

        const jsonResponse = await response.json();

        this.setState({ loading: false });

        if (!response.ok) {
            this.setState({ showError: true, errors: [...this.state.errors, jsonResponse.error.message] });
            return;
        }

        if (jsonResponse.error && jsonResponse.error.internal) {
            let messageInternalerror = "Erro interno no sistema: " + jsonResponse.error.message;
            this.setState({ showError: true, errors: [...this.state.errors, messageInternalerror] });
            return;
        }

        let userId = jsonResponse.uid;
        let uri = jsonResponse.links.href;
        let token = jsonResponse.accessToken;

        localStorage.setItem('token', token);

        //Redireciona para a pagina de alteração de senha default

        if (jsonResponse.defaultPassword) {
            console.log("baseurl: " + process.env.PUBLIC_URL);
            return this.props.history.push({
                pathname: urls.change.path,
                state: { uid: userId, uri: uri, token: token }
            })
        }

        //Redireciona para a pagina de conta existente

        if (jsonResponse.hasAccount) {
            let fullName = jsonResponse.fullName;
            let account = jsonResponse.account;

            return this.props.history.push({
                pathname: urls.exists.path,
                state: { uid: userId, fullName: fullName, account: account }
            })
        }

        //Redireciona para a pagina de escolha de conta institucional
        if (jsonResponse.accountChoices) {
            console.log("baseurl: " + process.env.PUBLIC_URL);
            return this.props.history.push({
                pathname: urls.choices.path,
                state: { uid: userId, uri: uri, token: token }
            })
        }
    };


    handleInputChange(event) {
        event.target.className = event.target.value.length === 0 ? "form-control is-invalid" : "form-control";
        this.setState({ [event.target.id]: event.target.value });
    }

    formValid(form) {        
        form.elements.username.className = this.state.username.length === 0 ? "form-control is-invalid" : "form-control";
        form.elements.password.className = this.state.password.length === 0 ? "form-control is-invalid" : "form-control";
        return this.state.username !== '' && this.state.password !== '';
    }

    renderForm() {        
        return (
            <form id="login-form" className="form-signin" method="POST" encType="application/json" onSubmit={this.handleSubmit}>
                <div className="form-group">
                    <div className="input-group">
                        <input id="username" type="text" name="cpf" className="form-control" placeholder="CPF" pattern="[0-9]{11}" onChange={e => this.handleInputChange(e)} />
                        <div className="input-group-append">
                            <span className="input-group-text glyphicon glyphicon-user">
                                <FontAwesomeIcon icon="user" />
                            </span>
                        </div>
                        <div className="invalid-feedback">
                            Por favor informe o seu numero de cpf.
                        </div>
                    </div>
                    <small className="form-text text-muted">Informe apenas números. Ex. 12345678901</small>
                </div>
                <div className="form-group">
                    <div className="input-group">
                        <input id="password" type="password" name="password" className="form-control" placeholder="Senha e-campus" onChange={e => this.handleInputChange(e)} />
                        <div className="input-group-append">
                            <span className="input-group-text glyphicon glyphicon-user">
                                <FontAwesomeIcon icon="lock" />
                            </span>
                        </div>
                        <div className="invalid-feedback">
                            Por favor informe a sua senha.
                        </div>
                    </div>
                    <small className="form-text text-muted">Informe sua senha do e-Campus</small>
                </div>
                <span id="confirmMessage" className="confirmMessage"></span>
                {this.state.loading ? <ButtonLoaddingSpinner /> : <button id="btn-submit-login" className="btn btn-lg btn-primary btn-block" type="submit">Enviar</button>}               
            </form>
        );
    }

    validateForm(input) {
        const errors = {};

        if (input.cpf.length !== 11)
            errors.cpf = 'CPF inválido';

        return errors;
    }

    render() {
        const errors = this.state.errors.map((e, i) => <li key={i}>{e}</li>);
        return (
            <Content>
                <span className="text text-center">
                    Vamos iniciar a criação de sua conta institucional. Para isso informe seu CPF e a senha de acesso ao e-Campus
                </span>
                {this.state.showError ? <ul className="alert alert-danger list-unstyled" role="alert">{errors}</ul> : <ul />}
                {this.renderForm()}                
            </Content>
        );
    }
}

export default LoginPage;
